import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import SecurityDash from '../containers/security/SecurityDash';
import Members from '../containers/security/Members';
import ChangePassword from '../containers/security/ChangePassword';
import OtherSecurities from "../containers/security/OtherSecurities";

class SecurityRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/security' component={SecurityDash}/>
                    <Route exact path='/security/password' component={ChangePassword}/>
                    <Route exact path='/security/users' component={Members}/>
                    <Route exact path='/security/others' component={OtherSecurities}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default SecurityRoute;



// WEBPACK FOOTER //
// ./src/routes/SecurityRoute.js